/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutPharmacyDispensingCountersRequestBodyTypename = "PutPharmacyDispensingCountersRequestBody" as const;

/**
 *
 * @export
 * @interface PutPharmacyDispensingCountersRequestBody
 */
export interface PutPharmacyDispensingCountersRequestBody {
  /**
   *
   * @type {Array<string>}
   * @memberof PutPharmacyDispensingCountersRequestBody
   */
  dispensingCounters: Array<string>;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutPharmacyDispensingCountersRequestBody
   */
  readonly __typename?: string;
}

export function PutPharmacyDispensingCountersRequestBodyFromJSON(json: any): PutPharmacyDispensingCountersRequestBody {
  return PutPharmacyDispensingCountersRequestBodyFromJSONTyped(json, false);
}

export function PutPharmacyDispensingCountersRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutPharmacyDispensingCountersRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutPharmacyDispensingCountersRequestBodyTypename,

    dispensingCounters: json["dispensing_counters"],
  };
}

export function PutPharmacyDispensingCountersRequestBodyToJSON(
  object?: PutPharmacyDispensingCountersRequestBody | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    dispensing_counters: value.dispensingCounters,
  };
}
